module.exports = __webpack_public_path__ + "static/media/sh.2e9c71c7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sh.svg
// module id = 244
// module chunks = 0